import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { timeout, catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';

const API_URL_SEMAFORIZACION = `${ENV.HOST}${URL_MAP.API.OPORTUNIDADES_COMERCIALES_EXTERNOS_SEMAFORIZACION}`;
const API_URL_MODAL = `${ENV.HOST}${URL_MAP.API.OPORTUNIDADES_COMERCIALES_EXTERNOS_MODAL}`;

const TIMEOUT_MS = 10000; // Tiempo de espera en milisegundos (10 segundos)
@Injectable({
  providedIn: 'root',
})
export class OportunidadesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.OPORTUNIDADES_COMERCIALES_EXTERNOS}`;
  constructor(private http: HttpClient) {}

  consultar(filtros: {
    id: number | null;
    tipoIdentificacion: string;
    numeroIdentificacion: string;
    estado?: string;
    fechaInicio?: string | null;
    fechaUltima?: string | null;
    codigoAsesor?: string | null;
  }): Observable<any[]> {
    return this.http.post<any[]>(`${this.apiUrl}/consultar`, filtros);
  }

  obtenerNumerosIdentificacionPorTipo(tipo: string): Observable<string[]> {
    const params = new HttpParams().set('tipo', tipo);
    return this.http.get<string[]>(`${this.apiUrl}/numeros-identificacion`, {
      params,
    });
  }

  finalizar(dto: {
    id: number;
    numeroIdentificacion: string;
    nuevoEstado: string;
    observaciones: string;
    usuario: string;
  }): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/finalizar`, dto);
  }

  obtenerBitacora(numeroIdentificacion: string): Observable<any[]> {
    const params = new HttpParams().set(
      'numeroIdentificacion',
      numeroIdentificacion
    );
    return this.http.get<any[]>(`${this.apiUrl}/bitacora`, { params });
  }

  public mostrarMensajeModal(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const requestBody = {
      nombreClave: 'getAlertMessage',
    };

    return this.http
      .post<any>(API_URL_MODAL, requestBody, { headers })
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }

  obtenerCodigoAsesor(cedula: string): Observable<number | null> {
    const url =
      `${ENV.HOST}${URL_MAP.API.CODIGOASESOR}`;

    const body = {
      nombreClave: 'getSpAsesorDocumento',
      jsonParametros: JSON.stringify({ prm_docu_asesor: cedula }),
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error consultando el código del asesor:', error);
        return [null];
      }),
      map((response) => response?.data?.[0]?.idasesor ?? null)
    );
  }

  public consultarReglasDeSemaforizacion(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const requestBody = {
      nombreClave: 'getOportunidadComercial',
      queryParams: '?page=0&size=1000',
      pathVariables: null,
      body: null,
    };

    return this.http
      .post<any>(API_URL_SEMAFORIZACION, requestBody, { headers })
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ha ocurrido un error inesperado.';
    if (error.error instanceof ErrorEvent) {
      mensaje = `Error de red o cliente: ${error.error.message}`;
    } else {
      switch (error.status) {
        case 400:
          mensaje = 'Solicitud incorrecta.';
          break;
        case 404:
          mensaje = 'Recurso no encontrado.';
          break;
        case 500:
          mensaje = 'Error del servidor.';
          break;
        default:
          mensaje = `Código de error: ${error.status}, mensaje: ${error.message}`;
          break;
      }
    }
    return throwError(() => new Error(mensaje));
  }
}
